import { render, staticRenderFns } from "./MedicineForm.vue?vue&type=template&id=4936c5dc&scoped=true"
import script from "./MedicineForm.vue?vue&type=script&lang=js"
export * from "./MedicineForm.vue?vue&type=script&lang=js"
import style0 from "./MedicineForm.vue?vue&type=style&index=0&id=4936c5dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4936c5dc",
  null
  
)

export default component.exports